// extracted by mini-css-extract-plugin
export default {"days":"VY5jU","day":"_1U3YF","empty":"_3apcA"};